import { useDragDropContext as context } from "@thisbeyond/solid-dnd";
import { isNil } from "lodash-es";

export const useDragDropContext = () => {
  const value = context();
  if (isNil(value)) {
    throw new Error("useDragDropContext must be used within an DragDropProvider");
  }
  return value;
};
